<div class="row" *ngIf="!selfVisitor">
    <div class="col-md-12">
        <app-util-visitor-parts-treatment-others-list-filter
                                            [selfVisitor]="selfVisitor"
                                            (filterEvent)="filterVisitorTreatments($event)"></app-util-visitor-parts-treatment-others-list-filter>
    </div>
</div>
<div class="row mt-5">
    <div class="col-md-12 align-items-center justify-content-space-between">
        <h5 class="title mb-3">
            <ng-container *ngIf="!archived">
                {{ 'VISITORS_MEDICAL.TREATMENT_OTHERS_IN_PROGRESS' | translate }}
            </ng-container>
            <ng-container *ngIf="archived">
                {{ 'VISITORS_MEDICAL.TREATMENT_OTHERS_HISTORY' | translate }}
            </ng-container>
        </h5>
        <ng-container *ngxPermissionsOnly="'cudVisitorTreatment'">
            <div *ngIf="!archived">
                <button type="button"
                        class="btn btn-primary btn-fill"
                        (click)="utilVisitorPartsTreatmentOthersModalsAdd.openModal(visitor?.id)">
                    <i class="fa fa-plus"></i> {{ 'VISITORS_MEDICAL.ADD_TREATMENT_OTHERS' | translate }}
                </button>
            </div>
        </ng-container>
    </div>
</div>
<div class="row mt-3">
    <div class="col-md-12">
        <ng-container *ngIf="!isLoading">
            <ng-container *ngIf="hasData?.visitorTreatmentOthers">
                <div class="overflow-auto pb-3">
                    <table class="table table-condensend table-striped">
                        <thead>
                            <tr>
                                <th class="p-3 text-center-important">#</th>
                                <ng-container *ngxPermissionsOnly="'cudVisitorTreatment'">
                                    <th class="p-3 text-center-important" *ngIf="!archived">{{ 'SHARED.ACTIONS' | translate }}</th>
                                </ng-container>
                                <ng-container *ngIf="!selfVisitor">
                                    <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.VISITOR' | translate }}</th>
                                </ng-container>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.NAME_AND_DOSAGE' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'FILTER.DATE_BEGIN' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'FILTER.DATE_END' | translate }}</th>
                                <th class="p-3 text-center-important">{{ 'VISITORS_MEDICAL.REMARKS' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let visitorTreatmentOther of visitorTreatmentOthers?.data; let i = index">
                                <td class="p-3 text-center-important" style="width: 70px;">{{ i + 1 }}</td>
                                <ng-container *ngxPermissionsOnly="'cudVisitorTreatment'">
                                    <td class="p-3 text-center-important td-actions"
                                        style="width: 100px;"
                                        *ngIf="!archived">
                                        <button type="button"
                                                class="btn btn-success btn-simple p-0"
                                                title="{{ 'VISITORS_MEDICAL.EDIT_TREATMENT_OTHERS' | translate }}"
                                                (click)="utilVisitorPartsTreatmentOthersModalsAdd.openModal(visitor?.id, visitorTreatmentOther)"
                                                appTooltip>
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button type="button"
                                                class="btn btn-danger btn-simple ml-3 p-0"
                                                title="{{ 'VISITORS_MEDICAL.DELETE_TREATMENT_OTHERS' | translate }}"
                                                (click)="delete(visitorTreatmentOther)"
                                                appTooltip>
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="!selfVisitor">
                                    <td class="p-3 text-center-important">
                                        <a [routerLink]="['/visitor', visitorTreatmentOther?.vId, 'infirmary', 'treatments']"
                                            class="text-primary">
                                            {{ visitorTreatmentOther?.showName }}
                                        </a>
                                    </td>
                                </ng-container>
                                <td class="p-3 text-center-important" style="width: 300px;">
                                    <app-text-limit [text]="visitorTreatmentOther?.medication_name" [limit]="30" [title]="'NAME_AND_DOSAGE'"></app-text-limit>
                                </td>
                                <td class="p-3 text-center-important" style="width: 120px;">
                                    {{ visitorTreatmentOther?.date_begin | localizedDate | ifEmpty: '-' }}
                                </td>
                                <td class="p-3 text-center-important" style="width: 120px;">
                                    {{ visitorTreatmentOther?.date_end | localizedDate | ifEmpty: '-'}}
                                </td>
                                <td class="p-3 text-center-important">
                                    <app-text-limit [text]="visitorTreatmentOther?.remarks" [title]="'REMARK'"></app-text-limit>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="align-items-center justify-content-center" *ngIf="visitorTreatmentOthers?.last_page > 1">
                        <app-pagination [data]="visitorTreatmentOthers" (switchPage)="switchPage($event)"></app-pagination>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!hasData?.visitorTreatmentOthers">
                <p>
                    {{ 'VISITORS_MEDICAL.NO_TREATMENT_OTHERS_FOUND' | translate }}
                </p>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="isLoading">
            <p>
                <app-loading-spinner></app-loading-spinner>
            </p>
        </ng-container>
    </div>
</div>
<app-util-visitor-parts-treatment-others-modals-add
    (addTreatmentEvent)="addTreatment()"
    #utilVisitorPartsTreatmentOthersModalsAdd></app-util-visitor-parts-treatment-others-modals-add>